var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0355 1.93679C14.8802 1.81574 14.689 1.75 14.4921 1.75C14.2953 1.75 14.104 1.81574 13.9487 1.93679L1.375 11.7412L2.46263 13.1167L4 11.9179V22.7495C4.00092 23.2134 4.1856 23.658 4.51358 23.986C4.84157 24.3139 5.28616 24.4986 5.75 24.4995H23.25C23.7138 24.4986 24.1584 24.3139 24.4864 23.986C24.8144 23.658 24.9991 23.2134 25 22.7495V11.9258L26.5374 13.1245L27.625 11.749L15.0355 1.93679ZM16.25 22.7495H12.75V15.7495H16.25V22.7495ZM18 22.7495V15.7495C17.9995 15.2856 17.815 14.8407 17.4869 14.5126C17.1588 14.1845 16.714 14 16.25 13.9995H12.75C12.286 14 11.8412 14.1845 11.5131 14.5126C11.185 14.8407 11.0005 15.2856 11 15.7495V22.7495H5.75V10.5538L14.5 3.73754L23.25 10.5625V22.7495H18Z",
    fill: "#88D57A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.932c1afad27287920b95f553eeb20e64.svg";
export { ForwardRef as ReactComponent };